import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductPrice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const { priceContainer, volumePricingNote } = this.refs;
        const newProductPrice = html.querySelector(
          `product-price[data-block-id="${this.dataset.blockId}"]`
        );

        if (!newProductPrice) return;

        const newPrice = newProductPrice.querySelector('[ref="priceContainer"]');

        if (newPrice && priceContainer) {
          priceContainer.replaceWith(newPrice);
        }

        const newNote = newProductPrice.querySelector('[ref="volumePricingNote"]');

        if (!newNote) {
          volumePricingNote?.remove();
        } else if (!volumePricingNote) {
          newPrice?.insertAdjacentElement('afterend', newNote.cloneNode(true));
        } else {
          volumePricingNote.replaceWith(newNote);
        }

        const installmentsInput = this.querySelector(
          `#product-form-installment-${this.dataset.blockId} input[name="id"]`
        );

        if (installmentsInput) {
          installmentsInput.value = detail.resource?.id ?? '';
          installmentsInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(
            '[product-price] Event promise rejected:',
            error
          );
        }
      });
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}